import { parsePlaceParts } from '../parse';
import { SelectionPhonetization, SelectionRomanization, SelectionCoordinates, SelectionAny } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionPlace extends SelectionWithNoteMixin(SelectionAny) {
    valueAsParts() {
        return this.value().map(parsePlaceParts);
    }
    getPhonetization() {
        return this.get("FONE" /* Tag.Phonetic */, null, SelectionPhonetization);
    }
    getRomanization() {
        return this.get("ROMN" /* Tag.Romanized */, null, SelectionRomanization);
    }
    getCoordinates() {
        return this.get("MAP" /* Tag.Map */, null, SelectionCoordinates);
    }
}
//# sourceMappingURL=SelectionPlace.js.map